/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface DashboardDemandeFormationSearch
 */
export interface DashboardDemandeFormationSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardDemandeFormationSearch
     */
    apprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardDemandeFormationSearch
     */
    module?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardDemandeFormationSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardDemandeFormationSearch
     */
    centre?: TextSearch;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDemandeFormationSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardDemandeFormationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardDemandeFormationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDemandeFormationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardDemandeFormationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardDemandeFormationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardDemandeFormationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardDemandeFormationSearch interface.
 */
export function instanceOfDashboardDemandeFormationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardDemandeFormationSearchFromJSON(json: any): DashboardDemandeFormationSearch {
    return DashboardDemandeFormationSearchFromJSONTyped(json, false);
}

export function DashboardDemandeFormationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardDemandeFormationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apprenant': !exists(json, 'apprenant') ? undefined : UnaccentTextSearchFromJSON(json['apprenant']),
        'module': !exists(json, 'module') ? undefined : UnaccentTextSearchFromJSON(json['module']),
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'centre': !exists(json, 'centre') ? undefined : TextSearchFromJSON(json['centre']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardDemandeFormationSearchToJSON(value?: DashboardDemandeFormationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apprenant': UnaccentTextSearchToJSON(value.apprenant),
        'module': UnaccentTextSearchToJSON(value.module),
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'centre': TextSearchToJSON(value.centre),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

